import React, { useState } from 'react';
import CampoComboEquipoEditable from '../../UI/campos/CampoComboEquipoEditable.js';
import CampoComboTitulo from '../../UI/campos/CampoComboTitulo.js';
import CampoComboMovimiento from '../../UI/campos/CampoComboMovimiento.js';
import CampoEditableTexto from '../../UI/campos/CampoEditableTexto.js';
import CampoEditableCheck from '../../UI/campos/CampoEditableCheck.js';
import * as Campos from '../../constantes/Campos.js';
import * as TipoParticipacion from '../../constantes/TipoParticipacionTorneo.js';
import * as TipoEquipo from '../../constantes/TipoEquipo.js';
import styles from './FilaTorneoParticipanteEditable.module.css';
import stylesTabla from '../CuadroListaEditable.module.css';

const FilaTorneoParticipanteEditable = (props) => {
  const item = props.item;
  const torneo = props.torneo;
  const equiposDisponibles = props.equiposDisponibles || [];
  const onGuardar = props.onGuardar;
  const onCancelar = props.onCancelar;
  const onItemChange = props.onItemChange;
  const rowIndex = props.index;

  const [itemEdicion, setItemEdicion] = useState(
    item || {
      equipo: null,
      organizador: false,
      tituloObtenido: null,
      movimientoDivisional: null,
      posicionFinal: null,
      partidosJugados: null,
      observaciones: '',
    }
  );

  const [guardando, setGuardando] = useState(false);

  const tipoParticipacion = torneo?.tipoTorneo?.tipoParticipacion;
  const dePais = torneo && torneo.pais && torneo.pais.id;

  // Determinar tipo de equipo inicial según tipo de participación del torneo
  let tipoEquipoInicial = null;
  if (
    tipoParticipacion === TipoParticipacion.CLUBES ||
    tipoParticipacion === TipoParticipacion.REGION ||
    tipoParticipacion === TipoParticipacion.PAIS
  ) {
    // PAIS = torneos de clubes de un país (ej: torneo argentino)
    // CLUBES = torneos de clubes internacionales (ej: Copa Libertadores)
    // REGION = torneos de clubes de una región
    tipoEquipoInicial = { codigo: TipoEquipo.CLUB, descripcion: 'Club' };
  } else if (tipoParticipacion === TipoParticipacion.SELECCIONES) {
    // SELECCIONES = torneos de selecciones nacionales (ej: Copa América, Mundial)
    tipoEquipoInicial = { codigo: TipoEquipo.SELECCION, descripcion: 'Selección' };
  }

  const onCampoChange = (campo, valor) => {
    let nuevoItem = { ...itemEdicion };

    switch (campo) {
      case Campos.TorneoParticipante.EQUIPO:
        nuevoItem.equipo = valor;
        break;
      case Campos.TorneoParticipante.ORGANIZADOR:
        nuevoItem.organizador = valor;
        break;
      case Campos.TorneoParticipante.TITULO_OBTENIDO:
        nuevoItem.tituloObtenido = valor;
        break;
      case Campos.TorneoParticipante.MOVIMIENTO_DIVISIONAL:
        nuevoItem.movimientoDivisional = valor;
        break;
      case Campos.TorneoParticipante.POSICION_FINAL:
        nuevoItem.posicionFinal = valor === '' || valor === null ? null : parseInt(valor, 10);
        break;
      case Campos.TorneoParticipante.PARTIDOS_JUGADOS:
        nuevoItem.partidosJugados = valor === '' || valor === null ? null : parseInt(valor, 10);
        break;
      case Campos.TorneoParticipante.OBSERVACIONES:
        nuevoItem.observaciones = valor;
        break;
      default:
        break;
    }

    setItemEdicion(nuevoItem);
    if (onItemChange) {
      onItemChange(rowIndex, nuevoItem);
    }
  };

  const handleGuardar = async () => {
    if (!itemEdicion.equipo) {
      alert('Debe seleccionar el equipo');
      return;
    }

    setGuardando(true);
    try {
      await onGuardar(itemEdicion);
      // Limpiar el formulario después de guardar exitosamente
      setItemEdicion({
        equipo: null,
        organizador: false,
        tituloObtenido: null,
        movimientoDivisional: null,
        posicionFinal: null,
        partidosJugados: null,
        observaciones: '',
      });
    } catch (error) {
      alert('Error al guardar: ' + error.message);
    } finally {
      setGuardando(false);
    }
  };

  const handleCancelar = () => {
    if (onCancelar) {
      onCancelar(item?.id ?? null);
    }
  };

  return (
    <tr className={`${styles.filaEditable}`}>
      <td className={`${styles.celda}`}>
        <CampoEditableTexto
          nombre={Campos.TorneoParticipante.POSICION_FINAL}
          valor={itemEdicion.posicionFinal ? itemEdicion.posicionFinal.toString() : ''}
          editar={true}
          largo={2}
          width="40px"
          onChange={onCampoChange}
        />
      </td>
      <td className={`${styles.celda}`}>
        <CampoComboEquipoEditable
          nombre={Campos.TorneoParticipante.EQUIPO}
          valor={itemEdicion.equipo}
          pais={torneo.pais}
          categoria={torneo.categoria}
          tipoEquipo={tipoEquipoInicial}
          anioTorneo={torneo.anioInicio}
          equipos={equiposDisponibles}
          onChange={onCampoChange}
        />
      </td>
      <td className={`${styles.celda}`} title="Partidos Jugados">
        <CampoEditableTexto
          nombre={Campos.TorneoParticipante.PARTIDOS_JUGADOS}
          valor={itemEdicion.partidosJugados ? itemEdicion.partidosJugados.toString() : ''}
          editar={true}
          largo={3}
          width="50px"
          onChange={onCampoChange}
        />
      </td>
      <td className={`${styles.celda}`} title="Organizador">
        <CampoEditableCheck
          nombre={Campos.TorneoParticipante.ORGANIZADOR}
          checked={itemEdicion.organizador || false}
          editar={true}
          onChange={onCampoChange}
        />
      </td>
      <td className={`${styles.celda}`}>
        <CampoComboTitulo
          nombre={Campos.TorneoParticipante.TITULO_OBTENIDO}
          valor={itemEdicion.tituloObtenido}
          editar={true}
          onChange={onCampoChange}
        />
      </td>
      <td className={`${styles.celda}`}>
        <CampoComboMovimiento
          nombre={Campos.TorneoParticipante.MOVIMIENTO_DIVISIONAL}
          valor={itemEdicion.movimientoDivisional}
          editar={true}
          onChange={onCampoChange}
        />
      </td>
      <td className={`${styles.celda}`}>
        <CampoEditableTexto
          nombre={Campos.TorneoParticipante.OBSERVACIONES}
          valor={itemEdicion.observaciones || ''}
          editar={true}
          largo={100}
          width="200px"
          onChange={onCampoChange}
        />
      </td>
      <td className={`${stylesTabla.editar} ${styles.botones}`}>
        <button
          className={`${styles.botonGuardar}`}
          onClick={handleGuardar}
          disabled={guardando}
          title="Guardar participante"
        >
          ✓
        </button>
        <button
          className={`${styles.botonCancelar}`}
          onClick={handleCancelar}
          disabled={guardando}
          title="Cancelar"
        >
          ✗
        </button>
      </td>
    </tr>
  );
};

export default FilaTorneoParticipanteEditable;
